// extracted by mini-css-extract-plugin
export var bubble = "_3x-0";
export var container = "_3x-3";
export var contrastBorder = "_3x-4";
export var greyOut = "_3x-2";
export var initialsWrapper = "_3x-1";
export var large = "_3x-9";
export var medium = "_3x-8";
export var mediumSmall = "_3x-7";
export var mediumSmallMedium = "_3x-c";
export var micro = "_3x-5";
export var small = "_3x-6";
export var tiny = "_3x-b";
export var xTiny = "_3x-a";